import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestBiztrip } from "../../entity/EntityRequestBiztrip";

export class DtoRequestBiztripsGetRes extends EntityRequestBiztrip {
  public items: EntityRequestBiztrip[]  = [];
}
